export default __webpack_public_path__ + "static/media/mic.f33253bf.svg";